import { StatementType } from "./index.js";
import { isArrayDimensionToken, isAutoIncrementValue, isByValue, isCharacterSet, isClusterBy, isCollateValue, isCommaToken, isCommentValue, isConstraintState, isConstraintValue, isDefaultValue, isEqualToken, isForeignValue, isGeneratedValue, isIndexKind, isIndexValue, isKeyValue, isLeftParentToken, isNewStatement, isNotValue, isNullFilter, isNullValue, isOnValue, isPeriodToken, isPrimaryValue, isReferencesValue, isRightParentToken, isSemicolonToken, isSignedValue, isStringToken, isTableItemWord, isTablespaceValue, isTypeModifier, isUniqueValue, isUsingValue, isWhereValue, matchCreateTable, matchDataType, matchKeyModifiers, matchNestedDataType, matchReferentialClause, matchUserDataType, requote, unquoteTypeName } from "../helper.js";
import { defaultExpressionParser, isNextvalDefault } from "./default.expression.js";
import { indexColumnsParser } from "./index.columns.js";
//#region ../schema-sql-parser/dist/parser/statement/create.table.js
function createTableParser(tokens, $pos, database) {
	const newStatement = isNewStatement(tokens);
	const isString = isStringToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const isPeriod = isPeriodToken(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isEqual = isEqualToken(tokens);
	const isComment = isCommentValue(tokens);
	const clusterBy = isClusterBy(tokens);
	const createTable = matchCreateTable(tokens);
	const isToken = () => $pos.value < tokens.length;
	const ast = {
		type: StatementType.createTable,
		name: "",
		comment: "",
		columns: [],
		indexes: [],
		keys: [],
		foreignKeys: []
	};
	const header = createTable($pos.value);
	$pos.value += header === 0 ? 2 : header;
	let hasColumns = false;
	let atColumnList = true;
	while (isToken() && !newStatement($pos.value)) {
		let token = tokens[$pos.value];
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (ast.name && clusterBy($pos.value)) {
			$pos.value += 2;
			if (isString($pos.value) && isLeftParent($pos.value + 1)) $pos.value++;
			if (isLeftParent($pos.value)) {
				let depth = 0;
				while (isToken()) {
					if (isLeftParent($pos.value)) depth++;
					else if (isRightParent($pos.value)) {
						depth--;
						if (depth === 0) {
							$pos.value++;
							break;
						}
					}
					$pos.value++;
				}
			}
			continue;
		}
		if (isLeftParent($pos.value)) {
			$pos.value++;
			if (hasColumns || !atColumnList) {
				let depth = 1;
				while (isToken() && depth > 0) {
					if (isLeftParent($pos.value)) depth++;
					else if (isRightParent($pos.value)) depth--;
					$pos.value++;
				}
				continue;
			}
			const { columns, indexes, keys, foreignKeys } = createTableColumnsParser(tokens, $pos, database);
			ast.columns = columns;
			ast.indexes = indexes;
			ast.keys = keys;
			ast.foreignKeys = foreignKeys;
			hasColumns = true;
			continue;
		}
		if (isString($pos.value) && !ast.name) {
			ast.name = token.value;
			atColumnList = true;
			$pos.value++;
			while (isPeriod($pos.value)) {
				if (!isString($pos.value + 1)) {
					$pos.value++;
					break;
				}
				ast.name = tokens[$pos.value + 1].value;
				$pos.value += 2;
			}
			continue;
		}
		if (isComment($pos.value)) {
			token = tokens[++$pos.value];
			if (isEqual($pos.value)) token = tokens[++$pos.value];
			if (isString($pos.value)) {
				ast.comment = token.value;
				$pos.value++;
			}
			atColumnList = false;
			continue;
		}
		atColumnList = false;
		$pos.value++;
	}
	return ast;
}
function createTableColumnsParser(tokens, $pos, database) {
	const isString = isStringToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const isComma = isCommaToken(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isPeriod = isPeriodToken(tokens);
	const isArrayDimension = isArrayDimensionToken(tokens);
	const isConstraint = isConstraintValue(tokens);
	const isIndex = isIndexValue(tokens);
	const isPrimary = isPrimaryValue(tokens);
	const isForeign = isForeignValue(tokens);
	const isAutoIncrement = isAutoIncrementValue(tokens);
	const isUnique = isUniqueValue(tokens);
	const isNull = isNullValue(tokens);
	const isNot = isNotValue(tokens);
	const isDefault = isDefaultValue(tokens);
	const isBy = isByValue(tokens);
	const isGenerated = isGeneratedValue(tokens);
	const nextvalDefault = isNextvalDefault(tokens);
	const isOn = isOnValue(tokens);
	const isComment = isCommentValue(tokens);
	const isKey = isKeyValue(tokens);
	const isReferences = isReferencesValue(tokens);
	const isEqual = isEqualToken(tokens);
	const characterSet = isCharacterSet(tokens);
	const isCollate = isCollateValue(tokens);
	const isUsing = isUsingValue(tokens);
	const isTablespace = isTablespaceValue(tokens);
	const isWhere = isWhereValue(tokens);
	const nullFilter = isNullFilter(tokens);
	const constraintState = isConstraintState(tokens);
	const dataType = matchDataType(tokens);
	const userDataType = matchUserDataType(tokens);
	const nestedDataType = matchNestedDataType(tokens);
	const referentialClause = matchReferentialClause(tokens);
	const keyModifiers = matchKeyModifiers(tokens);
	const indexKind = isIndexKind(tokens);
	const tableItemWord = isTableItemWord(tokens);
	const typeModifier = isTypeModifier(tokens);
	const isSigned = isSignedValue(tokens);
	const isToken = () => $pos.value < tokens.length;
	const isWords = (pos, words) => words.every((word, index) => !tokens[pos + index]?.quoted && tokens[pos + index]?.value.toUpperCase() === word);
	const onNullSpan = (pos) => {
		if (!isOn(pos) || !isNull(pos + 1)) return 0;
		if (isWords(pos + 2, [
			"FOR",
			"INSERT",
			"ONLY"
		])) return 5;
		if (isWords(pos + 2, [
			"FOR",
			"INSERT",
			"AND",
			"UPDATE"
		])) return 6;
		return 2;
	};
	const opensConstraintItem = (pos) => isConstraint(pos) || isPrimary(pos) || isForeign(pos) || isUnique(pos) || isIndex(pos) || isKey(pos) || indexKind(pos) || tableItemWord(pos);
	const columns = [];
	const indexes = [];
	const keys = [];
	const foreignKeys = [];
	const primaryKeyColumnNames = [];
	const uniqueColumnNames = [];
	let column = {
		name: "",
		dataType: "",
		default: "",
		comment: "",
		primaryKey: false,
		autoIncrement: false,
		unique: false,
		nullable: true
	};
	let constraintItem = false;
	let constraintName = "";
	let constraintEnd = -1;
	let unnamedKey = null;
	const oracleUsingIndex = (pos) => isUsing(pos) && isIndex(pos + 1) && !isTablespace(pos + 2);
	const symbolAt = (pos) => pos === constraintEnd ? constraintName : "";
	const filterAt = (pos) => {
		let depth = 0;
		for (; pos < tokens.length && !isSemicolon(pos); pos++) if (isLeftParent(pos)) depth++;
		else if (isRightParent(pos)) {
			if (depth-- === 0) return -1;
		} else if (depth === 0 && isComma(pos)) return -1;
		else if (depth === 0 && isWhere(pos)) return pos;
		return -1;
	};
	const addKey = (name, columnNames) => {
		if (!columnNames.length) return;
		if (name) keys.push({
			name,
			columnNames
		});
		else unnamedKey = {
			name,
			columnNames
		};
	};
	let typePos = -1;
	while (isToken()) {
		let token = tokens[$pos.value];
		if (unnamedKey && oracleUsingIndex($pos.value)) {
			keys.push(unnamedKey);
			unnamedKey = null;
		}
		const nestedLength = nestedDataType($pos.value);
		if (nestedLength) {
			const end = $pos.value + nestedLength;
			const parts = [];
			while ($pos.value < end) {
				parts.push(isComma($pos.value) ? "," : requote(tokens[$pos.value], database));
				$pos.value++;
			}
			column.dataType = parts.reduce((acc, part) => !acc || /^[,:>]/.test(part) ? acc + part : `${acc} ${part}`, "");
			continue;
		}
		const { span: referentialLength } = referentialClause($pos.value);
		if (referentialLength) {
			$pos.value += referentialLength;
			continue;
		}
		const inlineForeignKey = isForeign($pos.value) && isKey($pos.value + 1) && isReferences($pos.value + 2);
		if (column.name && !constraintItem && (isReferences($pos.value) || inlineForeignKey)) {
			if (inlineForeignKey) $pos.value += 2;
			const foreignKey = {
				columnNames: [column.name],
				refTableName: "",
				refColumnNames: [],
				onDelete: "",
				onUpdate: ""
			};
			referencesParser(tokens, $pos, foreignKey);
			if (foreignKey.refTableName && foreignKey.refColumnNames.length <= 1) foreignKeys.push(foreignKey);
			continue;
		}
		if (!column.name && opensConstraintItem($pos.value)) constraintItem = true;
		if (constraintItem && indexKind($pos.value)) {
			$pos.value++;
			continue;
		}
		if (isString($pos.value) && !constraintItem && !column.name && !isNot($pos.value) && !constraintState($pos.value)) {
			column.name = token.value;
			typePos = ++$pos.value;
			continue;
		}
		if (isLeftParent($pos.value)) {
			let depth = 0;
			while (isToken()) {
				if (isLeftParent($pos.value)) depth++;
				else if (isRightParent($pos.value)) {
					depth--;
					if (depth === 0) {
						$pos.value++;
						break;
					}
				}
				$pos.value++;
			}
			continue;
		}
		if (isConstraint($pos.value)) {
			token = tokens[++$pos.value];
			if (isString($pos.value) && !isUnique($pos.value) && !isPrimary($pos.value) && !isForeign($pos.value)) {
				constraintName = token.value;
				$pos.value++;
			}
			constraintEnd = $pos.value;
			continue;
		}
		if (isPrimary($pos.value)) {
			const name = symbolAt($pos.value);
			token = tokens[++$pos.value];
			if (isKey($pos.value)) {
				token = tokens[++$pos.value];
				if (constraintItem && isString($pos.value)) token = tokens[++$pos.value];
				if (isLeftParent($pos.value)) {
					const columnNames = indexColumnsParser(tokens, $pos).map((indexColumn) => indexColumn.name);
					primaryKeyColumnNames.push(...columnNames.map((columnName) => columnName.toUpperCase()));
					addKey(name, columnNames);
				} else if (column.name) {
					column.primaryKey = true;
					addKey(name, [column.name]);
				}
			}
			continue;
		}
		if (isForeign($pos.value)) {
			const foreignKey = parserForeignKeyParser(tokens, $pos);
			if (foreignKey) foreignKeys.push(foreignKey);
			continue;
		}
		if (isIndex($pos.value) || isKey($pos.value)) {
			token = tokens[++$pos.value];
			if (isString($pos.value)) {
				const name = token.value;
				token = tokens[++$pos.value];
				if (isUnique($pos.value)) {
					constraintName = name;
					continue;
				}
				if (isLeftParent($pos.value)) {
					const indexColumns = indexColumnsParser(tokens, $pos);
					if (indexColumns.length) indexes.push({
						name,
						unique: false,
						columns: indexColumns
					});
				}
			}
			continue;
		}
		if (isUnique($pos.value)) {
			const symbol = symbolAt($pos.value);
			token = tokens[++$pos.value];
			if (isKey($pos.value) || isIndex($pos.value)) token = tokens[++$pos.value];
			if (column.name) {
				column.unique = true;
				addKey(symbol, [column.name]);
				continue;
			}
			$pos.value += keyModifiers($pos.value);
			let name = constraintName;
			if (isString($pos.value)) {
				name = tokens[$pos.value].value;
				$pos.value++;
				$pos.value += keyModifiers($pos.value);
			}
			if (isLeftParent($pos.value)) {
				const indexColumns = indexColumnsParser(tokens, $pos);
				const columnNames = indexColumns.map((indexColumn) => indexColumn.name);
				const filter = filterAt($pos.value);
				if (filter !== -1 && !nullFilter(filter, columnNames)) {
					if (indexColumns.length) indexes.push({
						name,
						unique: false,
						columns: indexColumns
					});
				} else if (indexColumns.length > 1) {
					indexes.push({
						name,
						unique: true,
						columns: indexColumns
					});
					if (!name) addKey(name, columnNames);
				} else {
					uniqueColumnNames.push(...columnNames.map((columnName) => columnName.toUpperCase()));
					addKey(name, columnNames);
				}
			}
			continue;
		}
		if (isNot($pos.value)) {
			token = tokens[++$pos.value];
			if (isNull($pos.value)) {
				column.nullable = false;
				$pos.value++;
			} else if (constraintState($pos.value)) $pos.value++;
			continue;
		}
		if (constraintState($pos.value)) {
			$pos.value++;
			continue;
		}
		if (isDefault($pos.value)) {
			const identity = isBy($pos.value - 1) && isGenerated($pos.value - 2);
			$pos.value++;
			if (!identity) {
				$pos.value += onNullSpan($pos.value);
				const sequence = nextvalDefault($pos.value);
				const value = defaultExpressionParser(tokens, $pos, database);
				if (sequence) column.autoIncrement = true;
				else if (value) column.default = value;
			}
			continue;
		}
		if (isComment($pos.value)) {
			token = tokens[++$pos.value];
			if (isEqual($pos.value)) token = tokens[++$pos.value];
			if (isString($pos.value)) {
				column.comment = token.value;
				$pos.value++;
			}
			continue;
		}
		if (isAutoIncrement($pos.value)) {
			column.autoIncrement = true;
			$pos.value++;
			continue;
		}
		if (characterSet($pos.value)) {
			$pos.value += 2;
			if (isString($pos.value)) $pos.value++;
			continue;
		}
		if (isCollate($pos.value)) {
			$pos.value++;
			if (isEqual($pos.value)) $pos.value++;
			if (isString($pos.value)) $pos.value++;
			continue;
		}
		const knownLength = dataType($pos.value);
		const userLength = $pos.value === typePos ? userDataType($pos.value) : 0;
		const userDefined = userLength > 0 && (!knownLength || isPeriod($pos.value + 1));
		const dataTypeLength = userDefined ? userLength : knownLength;
		if (dataTypeLength && (constraintItem || column.dataType)) {
			$pos.value += dataTypeLength;
			continue;
		}
		if (dataTypeLength) {
			const end = $pos.value + dataTypeLength;
			let value = "";
			let depth = 0;
			while ($pos.value < end) {
				token = tokens[$pos.value];
				if (isLeftParent($pos.value)) {
					value += "(";
					depth++;
				} else if (isRightParent($pos.value)) {
					value += ")";
					depth--;
				} else if (depth) {
					const text = requote(token, database);
					value += isString($pos.value) && (isString($pos.value - 1) || isRightParent($pos.value - 1)) ? ` ${text}` : text;
				} else if (isArrayDimension($pos.value)) value += requote(token);
				else {
					const text = userDefined ? requote(token) : unquoteTypeName(token);
					value += value && !isPeriod($pos.value) && !isPeriod($pos.value - 1) ? ` ${text}` : text;
				}
				$pos.value++;
			}
			while (depth > 0) {
				value += ")";
				depth--;
			}
			while (typeModifier($pos.value)) {
				if (!isSigned($pos.value)) value += ` ${tokens[$pos.value].value}`;
				$pos.value++;
			}
			column.dataType = value;
			continue;
		}
		if (isComma($pos.value)) {
			if (column.name || column.dataType) columns.push(column);
			column = {
				name: "",
				dataType: "",
				default: "",
				comment: "",
				primaryKey: false,
				autoIncrement: false,
				unique: false,
				nullable: true
			};
			constraintItem = false;
			constraintName = "";
			unnamedKey = null;
			$pos.value++;
			continue;
		}
		if (isRightParent($pos.value)) {
			$pos.value++;
			break;
		}
		$pos.value++;
	}
	if (!columns.includes(column) && (column.name || column.dataType)) columns.push(column);
	columns.forEach((column) => {
		if (primaryKeyColumnNames.includes(column.name.toUpperCase())) column.primaryKey = true;
		if (uniqueColumnNames.includes(column.name.toUpperCase())) column.unique = true;
	});
	return {
		columns,
		indexes,
		keys,
		foreignKeys
	};
}
function parserForeignKeyParser(tokens, $pos) {
	const isString = isStringToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const isKey = isKeyValue(tokens);
	const isToken = () => $pos.value < tokens.length;
	const foreignKey = {
		columnNames: [],
		refTableName: "",
		refColumnNames: [],
		onDelete: "",
		onUpdate: ""
	};
	let token = tokens[++$pos.value];
	if (isKey($pos.value)) {
		token = tokens[++$pos.value];
		if (isLeftParent($pos.value)) {
			token = tokens[++$pos.value];
			while (isToken() && !isRightParent($pos.value)) {
				if (isString($pos.value)) foreignKey.columnNames.push(token.value);
				token = tokens[++$pos.value];
			}
			token = tokens[++$pos.value];
		}
		referencesParser(tokens, $pos, foreignKey);
		if (foreignKey.columnNames.length && foreignKey.refTableName && (!foreignKey.refColumnNames.length || foreignKey.columnNames.length === foreignKey.refColumnNames.length)) return foreignKey;
	}
	return null;
}
function referencesParser(tokens, $pos, foreignKey) {
	const isString = isStringToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const isReferences = isReferencesValue(tokens);
	const isPeriod = isPeriodToken(tokens);
	const referentialClause = matchReferentialClause(tokens);
	const isToken = () => $pos.value < tokens.length;
	if (!isReferences($pos.value)) return;
	let token = tokens[++$pos.value];
	if (!isString($pos.value)) return;
	foreignKey.refTableName = token.value;
	$pos.value++;
	while (isPeriod($pos.value)) {
		if (!isString($pos.value + 1)) {
			$pos.value++;
			break;
		}
		foreignKey.refTableName = tokens[$pos.value + 1].value;
		$pos.value += 2;
	}
	if (isLeftParent($pos.value)) {
		token = tokens[++$pos.value];
		while (isToken() && !isRightParent($pos.value)) {
			if (isString($pos.value)) foreignKey.refColumnNames.push(token.value);
			token = tokens[++$pos.value];
		}
		$pos.value++;
	}
	for (let clause = referentialClause($pos.value); clause.span; clause = referentialClause($pos.value)) {
		if (clause.event === "DELETE" && clause.action) foreignKey.onDelete = clause.action;
		else if (clause.event === "UPDATE" && clause.action) foreignKey.onUpdate = clause.action;
		$pos.value += clause.span;
	}
}
//#endregion
export { createTableParser, parserForeignKeyParser };
